import { ReactComponent as PepeWings } from "src/assets/svg/quiz/avatars/1.svg";
import { ReactComponent as Poseidon } from "src/assets/svg/quiz/avatars/2.svg";
import { ReactComponent as Explorer } from "src/assets/svg/quiz/avatars/3.svg";
import { ReactComponent as Furioush } from "src/assets/svg/quiz/avatars/4.svg";
import SelectPlayerFooter from "src/compnents/footer/quiz/Select.player.footer";
import { translationService } from "src/services/translation.service";
import useVotoStore from "src/store";
import { AvatarName } from "src/types/index.d";

const Step2 = () => {
    const {
        quiz: { playerCount, players },
        setAvatar,
        setPreviousSelectPlayerStep,
        setNextSelectPlayerStep,
        locale,
    } = useVotoStore();
    const firstPlayerAvatar = players.find((p) => p.id === 1)?.avatar;
    const secondPlayerAvatar = players.find((p) => p.id === 2)?.avatar;

    const selectCharText = translationService.translate(
        "quizPage.selectChar",
        locale
    );
    const pick_1Text = translationService.translate("quizPage.pick_1", locale);
    const whichPlayerText = translationService.translate(
        "quizPage.whichPlayer",
        locale
    );
    const poseidonText = translationService.translate(
        "quizPage.poseidon",
        locale
    );
    const explorerText = translationService.translate(
        "quizPage.explorer",
        locale
    );
    const pepewingsText = translationService.translate(
        "quizPage.pepewings",
        locale
    );
    const furioushText = translationService.translate(
        "quizPage.furioush",
        locale
    );

    const step2TitleText = playerCount === 1 ? whichPlayerText : pick_1Text;

    const handleSelectAvatar = (a: string, n: AvatarName) => {
        if (secondPlayerAvatar && a === secondPlayerAvatar) return;
        setAvatar(1, a, n);
    };

    return (
        <>
            <div className="voto-select-player voto-select-player__step2">
                <h2 className="white-text voto-select-player__title">
                    {step2TitleText}
                </h2>
                <div className="voto-select-player__step2__list">
                    <div
                        className={`${
                            secondPlayerAvatar === "1"
                                ? "avatar-disabled"
                                : firstPlayerAvatar === "1"
                                ? "avatar-selected"
                                : ""
                        }`}
                    >
                        <PepeWings
                            onClick={() =>
                                handleSelectAvatar("1", AvatarName.peppe)
                            }
                            className={`avatar`}
                        />
                        <h3 className="white-text">{pepewingsText}</h3>
                    </div>
                    <div
                        className={`${
                            secondPlayerAvatar === "2"
                                ? "avatar-disabled"
                                : firstPlayerAvatar === "2"
                                ? "avatar-selected"
                                : ""
                        }`}
                    >
                        <Poseidon
                            onClick={() =>
                                handleSelectAvatar("2", AvatarName.poseidon)
                            }
                            className={`avatar`}
                        />
                        <h3 className="white-text">{poseidonText}</h3>
                    </div>
                    <div
                        className={`${
                            secondPlayerAvatar === "3"
                                ? "avatar-disabled"
                                : firstPlayerAvatar === "3"
                                ? "avatar-selected"
                                : ""
                        }`}
                    >
                        <Explorer
                            onClick={() =>
                                handleSelectAvatar("3", AvatarName.explorer)
                            }
                            className={`avatar`}
                        />
                        <h3 className="white-text">{explorerText}</h3>
                    </div>
                    <div
                        className={`${
                            secondPlayerAvatar === "4"
                                ? "avatar-disabled"
                                : firstPlayerAvatar === "4"
                                ? "avatar-selected"
                                : ""
                        }`}
                    >
                        <Furioush
                            onClick={() =>
                                handleSelectAvatar("4", AvatarName.furioush)
                            }
                            className={`avatar`}
                        />
                        <h3 className="white-text">{furioushText}</h3>
                    </div>
                </div>
            </div>
            <SelectPlayerFooter
                guide={""}
                clickNext={setNextSelectPlayerStep}
                showBackButton={true}
                clickBack={setPreviousSelectPlayerStep}
                showNextButton={firstPlayerAvatar !== "empty"}
            />
        </>
    );
};
export default Step2;
